operations:
  load-models: Загрузить модели
  load-models-status:
    loading: Загрузка
    ready: Готово
docs:
  theme:
    navbar:
      appearance:
        title: Внешний вид
'controls-island':
  'fade-on-hover':
    enable: Скрывать при наведении
    disable: Всегда показывать
  'open-settings': Открыть настройки
  'open-chat': Открыть чат
  'refresh': Обновить результаты
  'open-hearing-controls': Управление слухом
  'drag-to-move-window': Перетащите окно
  'switch-to-light-mode': Переключить на светлую тему
  'switch-to-dark-mode': Переключить на темную тему
  'pin-on-top': Прикрепить на верх
  'unpin-from-top': Открепить сверху
  'switch-profile': Переключить профиль
  'close': Закрыть
  'expand': Развернуть
  'collapse': Свернуть
  'login': Войти
  'logging-in': Выполняется вход...
  'account': Аккаунт
  'logout': Выйти
notice:
  'fade-on-hover':
    title: Исчезать при наведении
    intro: Автоматически делает персонажа прозрачнее, когда курсор рядом. Меньше отвлекает, но остаётся видимым.
    opacity: После включения непрозрачность падает до {value} для {targets}, когда курсор рядом.
    toggle: Можно выключить, наведя на {controls} и снова нажав на {icon}.
    controls-label: Остров управления
    icon-label: значок перечёркнутого глаза
    value: '0'
    targets: Персонажа и интерфейса
    confirm: Понятно
    dont-show-again: Больше не показывать
    preparing: Подготавливаем…
    read-more: Подробнее
    preview-title: Что это?
about:
  subtitle: Desktop версия.
  current-version: Текущая версия
  common:
    cancel: Отменить
  links:
    title: Ссылки
    home: Главная
    documentation: Документация
    github: GitHub
  update:
    lane:
      label: Канал обновления
      description: Выберите релиз канала для отслеживания
      placeholder: Выбрать канал обновления
    channels:
      auto: Авто
      stable: Стабильный
      alpha: Альфа
      beta: Бета
      nightly: Nightly
      canary: Canary
    status:
      downloading: Загрузка обновления...
      error-prefix: Ошибка
      latest: Актуально (v{version}).
      downloaded:
        windows: Обновление готово к установке в автоматическом режиме (v{version}).
        restart: Обновление готово к установке после перезапуска (v{version}).
    actions:
      download: Загрузить обновление
      download-short: Загрузка
      confirm-download: Подтвердить загрузку
      check-for-updates: Проверить обновления
      checking: Проверка...
      latest-version: Последняя версия
      disabled-dev: Обновления отключены в Dev
      retry-check: Повторить проверку
      restart-silent: Перезапустите, чтобы обновить автоматически
      restart-install: Перезапустите для установки обновления
      confirm-restart: Подтвердить перезапуск
    dialog:
      title: Доступно обновление
      description: Доступна новая версия (v{version})
      no-release-notes-markdown: _Заметки о релизе не предоставлены._
